import { useTranslation } from 'react-i18next';

import { Modal } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

import DocumentPreview from '@/components/DocumentPreview/DocumentPreview';

import { isPlanResourceReference, mapReferenceToDocument } from '../utils';

import { BaseReferenceDto } from '@/_generated/api-clients/xp';

interface PreviewResourceModalProps {
  resourceReference: BaseReferenceDto;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const PreviewResourceModal: React.FC<PreviewResourceModalProps> = ({
  resourceReference,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation();

  if (!isPlanResourceReference(resourceReference)) {
    return null;
  }

  const doc = mapReferenceToDocument(resourceReference);
  const isTridion = doc.sourceSystem === 'TRIDION';

  return (
    <Modal.Overlay className="z-2000" isOpen={open} onOpenChange={onOpenChange}>
      <Modal.Dialog className="mx-4 flex! size-full! max-w-[840px]! flex-col! overflow-y-hidden! [&>section]:flex! [&>section]:h-full! [&>section]:flex-col!">
        <Modal.Title>
          <p className="text-variant-body1 text-center font-bold uppercase">
            {t('TrainingPlans.preview')}
          </p>
          <p className="text-variant-h2 text-grayscale-gray7 pt-2 pb-8 text-center">
            {resourceReference.name}
          </p>
        </Modal.Title>
        <Modal.Content className="bg-document-background-gray min-h-0! w-full! max-w-full! flex-auto! p-0!">
          <div
            className={cn(
              'flex size-full justify-center overflow-y-auto [&_div[data-tridion-content]>div]:pt-0!',
              {
                'w-full bg-white p-4': !isTridion,
                'shadow-elevation-4 max-w-[652px]! max-md:shadow-none':
                  isTridion,
              },
            )}
          >
            <DocumentPreview
              previewDocument={doc}
              handleGoBack={() => onOpenChange(false)}
              isTridionPreview={isTridion}
              isTemplatePreview
            />
          </div>
        </Modal.Content>
      </Modal.Dialog>
    </Modal.Overlay>
  );
};

export default PreviewResourceModal;
